import React, { useRef } from 'react';
import { HStack, VStack, Box } from '@cad-arc';
import { BoloPanelLeftPane } from './bolo-panel-left-pane';
import { BoloPanelFooter } from './bolo-panel-footer';
import { useExpandablePanelSize } from '../../../panels/expandable-panel-size';
import { BoloPanelRightPane } from './bolo-panel-right-pane';
import { BoloPanelTabs } from './tabs/bolo-panel-tabs';

export const BoloPanelBody = () => {
    const boloPanelSize = useExpandablePanelSize();

    const modalContainerRef = useRef<HTMLDivElement | null>(null);
    return (
        <VStack
            spacing={0}
            h="100%"
            w="100%"
            overflowY="hidden"
            position="relative"
            ref={modalContainerRef}
            data-testid="BOLO_PANEL_BODY"
        >
            <HStack spacing={0} overflowY="hidden" justifyContent="flex-start" w="100%" h="100%">
                <BoloPanelLeftPane />
                {boloPanelSize === 'XL' ? (
                    <BoloPanelRightPane />
                ) : boloPanelSize === 'XXL' ? (
                    <Box w="500px" h="100%" flexGrow={10000}>
                        <BoloPanelTabs mode="FULL" />
                    </Box>
                ) : undefined}
                {boloPanelSize === 'XXL' ? <BoloPanelRightPane /> : undefined}
            </HStack>
            <BoloPanelFooter />
        </VStack>
    );
};
